import type { pToggleVariants } from '@ui/components/core/p-toggle/index.js';
import type { VariantProps } from 'class-variance-authority';
import type { InjectionKey, Ref } from 'vue';

export type PToggleGroupVariants = VariantProps<typeof pToggleVariants>;

export interface PToggleGroupContext {
    variant: Ref<PToggleGroupVariants['variant'] | undefined>;
    size: Ref<PToggleGroupVariants['size'] | undefined>;
    rounded: Ref<boolean | undefined>;
    spacing: Ref<number | undefined>;
}

export const pToggleGroupContextKey: InjectionKey<PToggleGroupContext> = Symbol('pToggleGroup');
